import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import AuthUserContext from "./context";
import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/routes";
import PermissionDenied from "../PermissionDenied";

const withAuthorization = (condition) => (Component) => {
  const WithAuthorization = (props) => {
    const history = useHistory();

    console.log(props);
    useEffect(() => {
      const listener = props.firebase.auth.onAuthStateChanged((authUser) => {
        if (authUser) {
          props.firebase
            .user(authUser.uid)
            .once("value")
            .then((user) => {
              authUser = user.val() ? { ...authUser, ...user.val() } : null;
              if (!condition(authUser)) {
                //this.props.history.push(ROUTES.SIGN_IN);
              }
            });
        } else {
          history.push(ROUTES.SIGN_IN);
        }
      });

      return () => {
        listener();
      };
    }, []);

    return (
      <AuthUserContext.Consumer>
        {(authUser) => {
          return condition(authUser) ? <Component {...props} /> : <PermissionDenied />;
        }}
      </AuthUserContext.Consumer>
    );
  };
  /* class WithAuthorization extends React.Component {
    componentDidMount() {
      this.listener = this.props.firebase.auth.onAuthStateChanged((authUser) => {
        if (authUser) {
          this.props.firebase
            .user(authUser.uid)
            .once("value")
            .then((user) => {
              authUser = user.val() ? { ...authUser, ...user.val() } : null;
              if (!condition(authUser)) {
                //this.props.history.push(ROUTES.SIGN_IN);
              }
            });
        } else {
          this.props.history.push(ROUTES.SIGN_IN);
        }
      });
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      return (
        <AuthUserContext.Consumer>
          {(authUser) => {
            return condition(authUser) ? <Component {...this.props} /> : <PermissionDenied />;
          }}
        </AuthUserContext.Consumer>
      );
    }
  }*/

  return withFirebase(WithAuthorization);
};

export default withAuthorization;
